import React from 'react';
import Radium from 'radium';
import moment from 'moment';
import PropTypes from 'prop-types';
import { UTLabel } from '@widergy/energy-ui';

import { billPropTypes } from 'types/billTypes';
import { message } from 'utils/stringUtils';
import { appConfig } from 'config/customization';

import styles from './styles';

const fieldFilters = [
  { key: 'issued_on', show: true },
  { key: 'second_expiration_on', show: true },
  { key: 'second_expiration_amount', show: appConfig.useBillsSurchargeAmount },
  { key: 'period', show: true }
].filter(element => element.show);

const fieldFormatter = (key, value) => (
  <div style={styles.fieldContainer} key={key}>
    <UTLabel small bold>
      {message(`Bill:${key}`)}
    </UTLabel>
    <UTLabel small darkGray>
      {value}
    </UTLabel>
  </div>
);

const periodFormatter = (key, billData) =>
  billData.period_started_on &&
  billData.period_ended_on && (
    <div style={styles.fieldContainer} key={key}>
      <UTLabel small bold>
        {message(`Bill:${key}`)}
      </UTLabel>
      <UTLabel small darkGray>
        {billData.period_started_on &&
          billData.period_ended_on &&
          `${moment(billData.period_started_on).format('L')} - ${moment(billData.period_ended_on).format(
            'L'
          )}`}
      </UTLabel>
    </div>
  );

function BillDetails({ rowData, style }) {
  return (
    <div style={[styles.container, style]}>
      {fieldFilters.map(field =>
        field.key !== 'period'
          ? fieldFormatter(field.key, rowData[field.key])
          : periodFormatter(field.key, rowData)
      )}
    </div>
  );
}

BillDetails.propTypes = {
  rowData: PropTypes.shape(billPropTypes)
};

export default Radium(BillDetails);
